import { OwcAssistiveText, OwcIcon, OwcInput } from '@one/react';
import { config } from 'core/constants';
import { useTranslation } from 'core/i18n';

interface SearchInputComponentProps {
  value: string;
  onChange: (search: string) => void;
  autoFocus?: boolean;
  placeholder?: string;
  assistiveText?: string;
}

export const SearchInputComponent: React.FC<SearchInputComponentProps> = props => {
  const { value, onChange, autoFocus = true, placeholder, assistiveText } = props;

  const { t } = useTranslation('common');

  return (
    <OwcInput
      style={{ width: '100%' }}
      autoFocus={autoFocus}
      variant="outlined"
      placeholder={placeholder ?? t('components.search-input.placeholder')}
      onValueChange={ev => onChange(ev.detail)}
      value={value}
      controlled
      data-testid="search-input"
    >
      <OwcIcon slot="prefix" name="search" family="outlined" />
      <OwcAssistiveText slot="assistive-text">
        {assistiveText ??
          t('components.search-input.asistive-text', {
            chars: config.SEARCH_DEFAULT_MIN_CHARACTERS,
          })}
      </OwcAssistiveText>
    </OwcInput>
  );
};
